<div class="popup">
<mat-form-field class="example-full-width">
        <input matInput placeholder="Enter repository name" value="">
</mat-form-field>

<p class="fl-left">Drag on multiple files here</p>
<i class="upload_icon" style="--size:36px"></i>
<!-- <img class="upload_icon" src="assets/img/icons/upload.png"/> -->
<div class="clearfix"></div>
<button mat-raised-button class="btn m-b-20"  >SAVE</button>
</div>
